import { LANGUAGE_KEYS } from 'config/languageKeys';
import {
    ABOUT_APP_ID,
    AUDIO_SUBTITLES_ID,
    CHANNEL_LINEUP_SELECTION_ID,
    CONSENTS_ID,
    DELETE_HISTORY_ID,
    EPG_DISPLAY_ID,
    HELP_ID,
    HOME_MENU_ITEM_ID,
    INTERNET_CONNECTION_ID,
    LOG_OUT_ID,
    MY_STREAMING_SUBSCRIPTIONS_ID,
    ONDEMAND_MENU_ITEM_ID,
    PARENTAL_CONTROL_PIN_ID,
    RECORDINGS_MENU_ITEM_ID,
    RECORDING_QUOTA_ID,
    SPOTLIGHT_VIDEO_ID,
    TV_MENU_ITEM_ID,
} from 'config/testID';

import {
    APP_SETTINGS_LOGOUT_OPTION,
    SETTINGS_ABOUT_APP,
    SETTINGS_APP_LANGUAGE,
    SETTINGS_BACKEND_INFORMATION,
    SETTINGS_CHANNEL_LINEUP,
    SETTINGS_CONSENTS,
    SETTINGS_DELETE_HISTORY,
    SETTINGS_DISPLAY,
    SETTINGS_HELP,
    SETTINGS_LANGUAGE_AUDIO_SUBTITLES,
    SETTINGS_PARENTAL_CONTROL_AND_PIN,
    SETTINGS_RECORDING_QUOTA,
    SETTINGS_RN_INTERNET_CONNECTION_OPTIONS,
    SETTINGS_SPOTLIGHT_VIDEO,
    SETTINGS_STREAMING_SUBSCRIPTIONS,
} from 'screens/Settings/languagesConst';

import {
    MenuConfigurationItem,
    MenuItemType,
    RBTemplates,
} from '../reducer.types';

const {
    ACCESSIBILITY: {
        NAVIGATION: {
            ACCESSIBILITY_ICON_HOME,
            ACCESSIBILITY_ICON_EPG,
            ACCESSIBILITY_ICON_RECORDINGS,
            ACCESSIBILITY_ICON_ONDEMAND,
        },
    },
} = LANGUAGE_KEYS;

export const SUPPORTED_TEMPLATEVIEWS_NAMES = [
    RBTemplates.Home,
    RBTemplates.HomeKids,
    RBTemplates.TV,
    RBTemplates.Recordings,
    RBTemplates.OnDemand,
];

export const MODULAR_TEMPLATEVIEWS_NAMES = [
    RBTemplates.Home,
    RBTemplates.HomeKids,
    RBTemplates.Recordings,
    RBTemplates.OnDemand,
];

export const FALLBACK_TEMPLATEVIEWS: MenuConfigurationItem[] = [
    {
        id: RBTemplates.Home,
        name: RBTemplates.Home,
        type: MenuItemType.MODULAR,
        POEditorKey: 'MODULE_MAIN_MENU_HOME',
        icon: 'ico_home',
        testID: HOME_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_HOME,
    },
    {
        id: RBTemplates.HomeKids,
        name: RBTemplates.HomeKids,
        type: MenuItemType.MODULAR,
        POEditorKey: 'MODULE_MAIN_MENU_HOME',
        icon: 'ico_home',
        testID: HOME_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_HOME,
    },
    {
        id: RBTemplates.TV,
        name: RBTemplates.TV,
        type: MenuItemType.EPG,
        POEditorKey: 'MODULE_MAIN_MENU_TV',
        icon: 'ico_tv',
        testID: TV_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_EPG,
    },
    {
        id: RBTemplates.Recordings,
        name: RBTemplates.Recordings,
        type: MenuItemType.MODULAR,
        POEditorKey: 'MODULE_MAIN_MENU_RECORDINGS',
        icon: 'ico_recordings',
        testID: RECORDINGS_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_RECORDINGS,
    },
    {
        id: RBTemplates.OnDemand,
        name: RBTemplates.OnDemand,
        type: MenuItemType.MODULAR,
        POEditorKey: 'MODULE_MAIN_MENU_ONDEMAND',
        icon: 'ico_on_demand',
        testID: ONDEMAND_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_ONDEMAND,
    },
];

export const FALLBACK_SETTINGS_CONFIG: MenuConfigurationItem[] = [
    {
        id: RBTemplates.ChannelLineup,
        name: RBTemplates.ChannelLineup,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_CHANNEL_LINEUP,
        icon: 'ico_channel_lineup',
    },
    {
        id: RBTemplates.Quota,
        name: RBTemplates.Quota,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_RECORDING_QUOTA,
        icon: 'ico_quota',
    },
    {
        id: RBTemplates.InternetConnection,
        name: RBTemplates.InternetConnection,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_RN_INTERNET_CONNECTION_OPTIONS,
        icon: 'ico_internet_connection',
    },
    {
        id: RBTemplates.AudioSubtitles,
        name: RBTemplates.AudioSubtitles,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_LANGUAGE_AUDIO_SUBTITLES,
        icon: 'ico_comment',
    },
    {
        id: RBTemplates.Consents,
        name: RBTemplates.Consents,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_CONSENTS,
        icon: 'ico_consent',
    },
    {
        id: RBTemplates.SpotlightVideo,
        name: RBTemplates.SpotlightVideo,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_SPOTLIGHT_VIDEO,
        icon: 'ico_spotlight',
    },
    {
        id: RBTemplates.About,
        name: RBTemplates.About,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_ABOUT_APP,
        icon: 'ico_info',
    },
    {
        id: RBTemplates.Subscriptions,
        name: RBTemplates.Subscriptions,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_STREAMING_SUBSCRIPTIONS,
        icon: 'ico_subscription',
    },
    {
        id: RBTemplates.Help,
        name: RBTemplates.Help,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_HELP,
        icon: 'ico_help',
    },
    {
        id: RBTemplates.SignOut,
        name: RBTemplates.SignOut,
        type: MenuItemType.SETTINGS,
        POEditorKey: APP_SETTINGS_LOGOUT_OPTION,
        icon: 'ico_sign_out',
    },
];

export const FALLBACK_KIDS_SETTINGS_CONFIG: MenuConfigurationItem[] = [
    {
        id: RBTemplates.AudioSubtitlesKids,
        name: RBTemplates.AudioSubtitlesKids,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_LANGUAGE_AUDIO_SUBTITLES,
        icon: 'ico_comment',
    },
    {
        id: RBTemplates.BackendInfoKids,
        name: RBTemplates.BackendInfoKids,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_BACKEND_INFORMATION,
        icon: 'ico_info',
    },
    {
        id: RBTemplates.AboutKids,
        name: RBTemplates.AboutKids,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_ABOUT_APP,
        icon: 'ico_info',
    },
    {
        id: RBTemplates.HelpKids,
        name: RBTemplates.HelpKids,
        type: MenuItemType.SETTINGS,
        POEditorKey: SETTINGS_HELP,
        icon: 'ico_help',
    },
];

export const NON_INTERACTIVE_EXCLUDED_MENU_ITEMS = [
    RBTemplates.SpotlightVideo,
    RBTemplates.Quota,
];

export const MENU_ITEMS_ADDITIONAL_PARAMS = {
    // Root pages related config
    [RBTemplates.Home]: {
        POEditorKey: 'MODULE_MAIN_MENU_HOME',
        icon: 'ico_home',
        testID: HOME_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_HOME,
    },
    [RBTemplates.HomeKids]: {
        POEditorKey: 'MODULE_MAIN_MENU_HOME',
        icon: 'ico_home',
        testID: HOME_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_HOME,
    },
    [RBTemplates.TV]: {
        POEditorKey: 'MODULE_MAIN_MENU_TV',
        icon: 'ico_tv',
        testID: TV_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_EPG,
    },
    [RBTemplates.Catchup]: {
        POEditorKey: 'MODULE_MAIN_MENU_CATCHUP',
        icon: 'ico_catchup',
    },
    [RBTemplates.Recordings]: {
        POEditorKey: 'MODULE_MAIN_MENU_RECORDINGS',
        icon: 'ico_recordings',
        testID: RECORDINGS_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_RECORDINGS,
    },
    [RBTemplates.OnDemand]: {
        POEditorKey: 'MODULE_MAIN_MENU_ONDEMAND',
        icon: 'ico_on_demand',
        testID: ONDEMAND_MENU_ITEM_ID,
        accessibilityLabel: ACCESSIBILITY_ICON_ONDEMAND,
    },

    // Settings related config
    [RBTemplates.Language]: {
        POEditorKey: SETTINGS_APP_LANGUAGE,
        icon: 'ico_flag',
    },
    [RBTemplates.Parental]: {
        POEditorKey: SETTINGS_PARENTAL_CONTROL_AND_PIN,
        icon: 'ico_kids',
        testID: PARENTAL_CONTROL_PIN_ID,
    },
    [RBTemplates.Quota]: {
        POEditorKey: SETTINGS_RECORDING_QUOTA,
        icon: 'ico_quota',
        testID: RECORDING_QUOTA_ID,
    },
    [RBTemplates.InternetConnection]: {
        POEditorKey: SETTINGS_RN_INTERNET_CONNECTION_OPTIONS,
        icon: 'ico_internet_connection',
        testID: INTERNET_CONNECTION_ID,
    },
    [RBTemplates.ChannelLineup]: {
        POEditorKey: SETTINGS_CHANNEL_LINEUP,
        icon: 'ico_channel_lineup',
        testID: CHANNEL_LINEUP_SELECTION_ID,
    },
    [RBTemplates.Subscriptions]: {
        POEditorKey: SETTINGS_STREAMING_SUBSCRIPTIONS,
        icon: 'ico_subscription',
        testID: MY_STREAMING_SUBSCRIPTIONS_ID,
    },
    [RBTemplates.EpgDisplay]: {
        POEditorKey: SETTINGS_DISPLAY,
        icon: 'ico_epg_display',
        testID: EPG_DISPLAY_ID,
    },
    [RBTemplates.AudioSubtitles]: {
        POEditorKey: SETTINGS_LANGUAGE_AUDIO_SUBTITLES,
        icon: 'ico_comment',
        testID: AUDIO_SUBTITLES_ID,
    },
    [RBTemplates.AudioSubtitlesKids]: {
        POEditorKey: SETTINGS_LANGUAGE_AUDIO_SUBTITLES,
        icon: 'ico_comment',
        testID: AUDIO_SUBTITLES_ID,
    },
    [RBTemplates.DeleteHistory]: {
        POEditorKey: SETTINGS_DELETE_HISTORY,
        icon: 'ico_delete_history',
        testID: DELETE_HISTORY_ID,
    },
    [RBTemplates.Consents]: {
        POEditorKey: SETTINGS_CONSENTS,
        icon: 'ico_consent',
        testID: CONSENTS_ID,
    },
    [RBTemplates.SpotlightVideo]: {
        POEditorKey: SETTINGS_SPOTLIGHT_VIDEO,
        icon: 'ico_spotlight',
        testID: SPOTLIGHT_VIDEO_ID,
    },
    [RBTemplates.About]: {
        POEditorKey: SETTINGS_ABOUT_APP,
        icon: 'ico_info',
        testID: ABOUT_APP_ID,
    },
    [RBTemplates.AboutKids]: {
        POEditorKey: SETTINGS_ABOUT_APP,
        icon: 'ico_info',
        testID: ABOUT_APP_ID,
    },
    [RBTemplates.Help]: {
        POEditorKey: SETTINGS_HELP,
        icon: 'ico_help',
        testID: HELP_ID,
    },
    [RBTemplates.HelpKids]: {
        POEditorKey: SETTINGS_HELP,
        icon: 'ico_help',
        testID: HELP_ID,
    },
    [RBTemplates.BackendInfo]: {
        POEditorKey: SETTINGS_BACKEND_INFORMATION,
        icon: 'ico_info',
    },
    [RBTemplates.BackendInfoKids]: {
        POEditorKey: SETTINGS_BACKEND_INFORMATION,
        icon: 'ico_info',
    },
    [RBTemplates.TermsConditions]: {
        POEditorKey: 'SETTINGS_TERM_AND-CONDITIONS_TITLE',
        icon: 'ico_info',
    },
    [RBTemplates.SignOut]: {
        POEditorKey: APP_SETTINGS_LOGOUT_OPTION,
        icon: 'ico_sign_out',
        testID: LOG_OUT_ID,
    },
};
